import angular from 'angular';
import { cloneDeep } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import '../services/connect-wizard';

const module = angular.module('whyline.controllers.connect-wizard', [
  'whyline.services.connect-wizard',
]);

const ConnectWizardController = ($scope, $translate, $uibModalInstance, ConnectWizardService, connectWizardData, ErrorService, NotificationService) => {
  /*@ngInject*/

  $scope.editMode = !!connectWizardData;
  $scope.resetSecret = !$scope.editMode;
  $scope.resetPassword = !$scope.editMode;
  $scope.repeatPassword = '';
  $scope.passwordLabel = $scope.editMode ? 'change_password' : 'password';
  $scope.model = connectWizardData || ConnectWizardService.CreateInstance();
  $scope.urlPattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
  $scope.emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  $scope.setResetSecret = () => {
    $scope.resetSecret = true;
    $scope.model.apiClientSecret = uuidv4();
  };

  $scope.setResetPassword = () => {
    $scope.resetPassword = true;
  };

  const validate = () => {
    const name = $scope.model.name;
    const apiUrl = $scope.model.apiUrl;
    const apiClientKey = $scope.model.apiClientKey;
    const apiClientSecret = $scope.model.apiClientSecret;
    const email = $scope.model.email;
    const password = $scope.model.password;

    const repeatPassword = $scope.repeatPassword;
    const urlPattern = $scope.urlPattern;
    const emailPattern = $scope.emailPattern;
    const editMode = $scope.editMode;

    if (!name) {
      NotificationService.Warning($translate.instant('name_mandatory'));
      return false;
    }

    if (!apiUrl) {
      NotificationService.Warning($translate.instant('mandatory_{name}').replace('{name}', 'API URL'));
      return false;
    }

    if (!editMode && !apiClientKey) {
      NotificationService.Warning($translate.instant('mandatory_{name}').replace('{name}', 'API CLIENT KEY'));
      return false;
    }

    if (!editMode && !apiClientSecret) {
      NotificationService.Warning($translate.instant('mandatory_{name}').replace('{name}', 'API CLIENT SECRET'));
      return false;
    }

    if (!editMode && !email) {
      NotificationService.Warning($translate.instant('mandatory_email'));
      return false;
    }

    if (email && !emailPattern.test(email)) {
      NotificationService.Warning($translate.instant('invalid_email_format'));
      return false;
    }

    if (password && password !== repeatPassword) {
      NotificationService.Warning($translate.instant('unmatch_pw'));
      return false;
    }

    if (repeatPassword && repeatPassword !== password) {
      NotificationService.Warning($translate.instant('unmatch_pw'));
      return false;
    }

    if (!editMode && (!password || password.length < 6)) {
      NotificationService.Warning($translate.instant('min_length_new_pw'));
      return false;
    }

    if (editMode && (password && password.length > 0 && password.length < 6)) {
      NotificationService.Warning($translate.instant('min_length_new_pw'));
      return false;
    }

    return true;
  };

  const closeModal = () => $uibModalInstance.close('saved');

  const handleSavePromise = promise => {
    promise
      .then(closeModal)
      .catch(ErrorService.handler);
  };

  const saveConnectData = dataToSave => {
    handleSavePromise(ConnectWizardService.SaveConnectData(dataToSave));
  };

  const updateConnectData = dataToSave => {
    handleSavePromise(ConnectWizardService.UpdateConnectData(dataToSave));
  };

  $scope.cancel = () => closeModal();

  $scope.save = () => {
    if (validate()) {
      const dataToSave = cloneDeep($scope.model);
      if (!$scope.editMode) {
        saveConnectData(dataToSave);
      } else {
        updateConnectData(dataToSave);
      }
    }
  };
};

module.exports = module.controller('ConnectWizardController', ConnectWizardController);
